import Backdrop from '@material-ui/core/Backdrop';
import CustomForms from '@template/customForms';
import { CloseLargeIcon, IconFrame } from '@element/icons';


function CustomFormModal({ open, handleClose, formDetails }) {

    const closeModal = () => {
        handleClose(null);
    }

    return (
        <Backdrop className="backdrop-modal-wrapper custom-form-modal-wrap" open={open ? true : false}>
            <div className="backdrop-modal-content" style={{ height: open ? '88vh' : '0px' }}>
                <div className="modal-close" onClick={closeModal}>
                    <IconFrame><CloseLargeIcon /></IconFrame>
                </div>
                <div className="address-modal">
                    <CustomForms initialFormDetails={formDetails} />
                </div>
            </div>
        </Backdrop>
    );
}

export default CustomFormModal;